import { useEffect, useState } from "react";
import { api } from "../../../interceptors/api";
import { DeviceVisualDto } from "../dto/DeviceVisualDto";
import "./styles/WelcomeScreen.css";
import { WindowTypeEnum } from "./enums/WindowTypeEnum";

interface WelcomeScreenProps {
  onOpen: (windowType: WindowTypeEnum) => void;
}

function WelcomeScreen({ onOpen }: WelcomeScreenProps) {
  const [backgroundImage, setBackgroundImage] = useState<string>("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get<DeviceVisualDto>("/api/device-visual/device/4/exhibition/4")
      .then((res) => {
        setBackgroundImage(res.data.visualUrl);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to load device visual:", err);
        setLoading(false);
      });
  }, []);

  const handleClick = (windowType: WindowTypeEnum) => {
    setTimeout(() => {
      onOpen(windowType);
    }, 200);
  };

  return (
    <div
      className="imac-welcome"
      role="button"
      tabIndex={0}
      onClick={() => handleClick(WindowTypeEnum.VisitorStories)}
      style={{
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
        cursor: "pointer",
      }}
    >
      {loading && (
        <div
          style={{ color: "white", textAlign: "center", paddingTop: "50vh" }}
        >
          Loading...
        </div>
      )}
    </div>
  );
}

export default WelcomeScreen;
